import { DateTime } from 'luxon';

/**
 * Returns a human-readable relative time string for a given epoch-ms timestamp.
 * @param {number|null|undefined} ts
 * @returns {string|null}
 */
export const relativeTime = (ts) => {
  if (!ts) return null;
  const diff  = DateTime.now().diff(DateTime.fromMillis(ts));
  const mins  = diff.as('minutes');
  const hours = diff.as('hours');
  const days  = diff.as('days');
  if (mins  <  60) return `${Math.round(mins)} mins ago`;
  if (hours < 24)  return `${Math.round(hours)} hrs ago`;
  return `${Math.round(days)} days ago`;
};

/**
 * Returns an MUI color name for an "updated" chip based on the timestamp's age.
 * @param {number|null|undefined} ts
 * @returns {'success'|'warning'|'error'|'default'}
 */
export const updatedChipColor = (ts) => {
  if (!ts) return 'default';
  const hours = DateTime.now().diff(DateTime.fromMillis(ts)).as('hours');
  if (hours < 4) return 'success';
  if (hours < 8) return 'warning';
  return 'error';
};

/**
 * Returns true if the timestamp is >= 8 hours old (stale threshold).
 * @param {number|null|undefined} ts
 * @returns {boolean}
 */
export const isStale = (ts) =>
  ts ? DateTime.now().diff(DateTime.fromMillis(ts)).as('hours') >= 8 : false;
